import React, { useState } from 'react';
import { Autocomplete, TextField, Checkbox, ListItemIcon, ListItemText } from '@mui/material';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

function AutocompleteWithAll({ options, props_sx, props, selectedOptions, setSelectedOptions }) {
  //const [selectedOptions, setSelectedOptions] = useState([]);

  const allOptions = [{ value: 0, label: 'Select All' }, ...options];

  const handleToggleSelectAll = (checked) => {
    if (checked) {
      setSelectedOptions(options); // Select all regular options
    } else {
      setSelectedOptions([]); // Deselect all
    }
  };

  const handleChange = (event, newValue) => {
    const selectAllOption = newValue.find((option) => option.value === 0);

    if (selectAllOption) {
      // If "Select All" was clicked
      const isCurrentlySelected = selectedOptions.length === options.length;
      handleToggleSelectAll(!isCurrentlySelected);
    } else {
      setSelectedOptions(newValue);
    }
  };

  return (
    <Autocomplete
      multiple size='small'
      disableCloseOnSelect
      options={allOptions}
      value={selectedOptions}
      onChange={handleChange}
      getOptionLabel={(option) => option.label}
      sx={props_sx}
      renderOption={(props, option, { selected }) => (
        <li {...props} key={option.value}>
          <ListItemIcon>
            <Checkbox
              icon={icon}
              checkedIcon={checkedIcon}
              style={{ marginRight: 8 }}
              checked={
                option.value === 0
                  ? selectedOptions.length === options.length && options.length > 0
                  : selected
              }
            />
          </ListItemIcon>
          <ListItemText primary={option.label} />
        </li>
      )}
      renderInput={(params) => (
        <TextField {...params} label={props.label} placeholder={props.placeholder} />
      )}
    />
  );
}

export default AutocompleteWithAll;